module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescir3-1eead2f2d504a800d876c4de94d8ebe8.jpg";